import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

/**
 * ProtectedRoute komponent der håndterer rollebaseret adgangskontrol
 * @param {Object} props
 * @param {React.ReactNode} props.children - Komponenten der skal vises hvis brugeren har adgang
 * @param {string[]} props.allowedRoles - Array af tilladte roller
 * @param {boolean} props.requireClientId - Om brugeren skal have en clientId
 * @param {Function} props.customCheck - Ekstra valideringsfunktion
 */
const ProtectedRoute = ({ 
  children, 
  allowedRoles = [], 
  requireClientId = false,
  customCheck = null 
}) => {
  const location = useLocation();
  const { user, isLoggedIn } = useUser();

  // Hvis brugeren ikke er logget ind, redirect til login
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Tjek om brugerens rolle er tilladt
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Tjek om clientId er påkrævet
  if (requireClientId && !user.clientId) {
    return <Navigate to="/admin" replace />;
  }

  // Ekstra validering via customCheck
  if (customCheck && !customCheck(user)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute; 